import styled, { css } from 'styled-components';
import React from 'react';

type TextAlign = 'left' | 'center' | 'right' | 'justify';
export type FontWeight = '200' | '300' | '400' | '500' | '600' | '700' | '800' | '900';

export interface ITypography {
  $align?: TextAlign;
  $noWrap?: boolean;
  $truncate?: boolean;
  $lineClamp?: number;
  $fontWeight?: FontWeight;
  $as?: React.ElementType;
}

const Typography = styled.div<ITypography>`
  font-family: var(--mio-font-family-body, sans-serif);
  margin: 0;
  padding: 0;
  text-align: ${({ $align }) => $align};
  font-weight: ${({ $fontWeight }) => ($fontWeight ? `var(--mio-font-weight-${$fontWeight})` : 'inherit')};
  ${({ $noWrap }) =>
    $noWrap &&
    css`
      white-space: nowrap;
    `}
  ${({ $truncate }) =>
    $truncate &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    `}

  ${({ $lineClamp }) =>
    $lineClamp &&
    css`
      display: -webkit-box;
      -webkit-line-clamp: ${$lineClamp};
      -webkit-box-orient: vertical;
      overflow: hidden;
    `}
`;

export default Typography;
